import { render, staticRenderFns } from "./QuestionFormMail.vue?vue&type=template&id=70d8b902&scoped=true"
import script from "./QuestionFormMail.vue?vue&type=script&lang=js"
export * from "./QuestionFormMail.vue?vue&type=script&lang=js"
import style0 from "./QuestionFormMail.vue?vue&type=style&index=0&id=70d8b902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d8b902",
  null
  
)

export default component.exports